// extracted by mini-css-extract-plugin
export default {"inner":"styles_inner__V1imq","heading":"styles_heading__JIuY0","steps":"styles_steps__KjZDP","number":"styles_number__nQEMB"};